import {Base64, uniqBy, kebabCase, isEqual, createReducer} from 'helpers';

export const categories = createReducer([], {

  SERVER_DATA_RECEIVED: (state, { categorizedHabitTypes }) => {
    const categories = uniqBy([
      ...state,
      ...categorizedHabitTypes.map(category => ({
        id: category.serverId,
        name: Base64.decode(category.name),
        slug: kebabCase(Base64.decode(category.name)),
      }))
    ], 'id');
    return isEqual(state, categories) ? state : categories;
  }

});

